import { render } from "./fichaPaciente.vue?vue&type=template&id=6725541e&scoped=true"
import script from "./fichaPaciente.vue?vue&type=script&lang=js"
export * from "./fichaPaciente.vue?vue&type=script&lang=js"

import "./fichaPaciente.vue?vue&type=style&index=0&id=6725541e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6725541e"]])

export default __exports__